<template>
  <Card tag="form" class="residential-mutate-devtools" @submit.prevent="$emit('submit')" :title="$t('devtools')">
    <template #default>
      <CustomFields
        :value="value"
        @input="e => $emit('updateValue', e)"
        :schema="customFieldSchemas"
        :data="value"
        :validator="validator"
        :placement="['devtools', 'residential:devtools']"
        :disabledFields="$path('metadata.disabledFields', item)"
      >
        <!-- render slots -->
        <template v-for="item in fields.slots" v-slot:[item.slotKey]>
          <FieldRenderer
            :validator="validator"
            :item="item"
            :value="value"
            @input="e => $emit('updateValue', { ...e, slot: true })"
          />
        </template>
      </CustomFields>
    </template>
  </Card>
</template>

<script>
import { mapState } from 'vuex'
import { i18n } from '@/i18n'
import Store from '@/store'

import Card from '@/components/Card'
import { InputComponent } from 'vue-elder-input'
import CustomFields from '@kvass/custom-fields'

const meta = {
  order: 5,
  skip: !Store.getters.isDeveloper,
  id: 'devtools',
  label: i18n.t('devtools'),
  icon: ['fal', 'code'],
}

export { meta }
export default {
  props: {
    value: Object,
    labels: Object,
    validator: Object,
    customFieldSchemas: { type: Array, default: () => [] },
    fields: { type: Object, default: () => ({}) },
  },
  computed: {
    ...mapState('Residential', ['item']),
  },
  components: {
    Card,
    InputComponent,
    CustomFields,
  },
}
</script>

<style lang="scss">
.residential-mutate-devtools {
  max-width: 900px;
}
</style>
